<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">
                        New Team
                    </div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style="" to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style="" to="/admin/teams" v-bind:exact="exact">Teams</v-breadcrumbs-item>
                        <v-breadcrumbs-item style="" to="/admin/teams/new" v-bind:exact="exact">New Team</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field
                                    name="team"
                                    label="Team"
                                    v-model="team"
                                    v-bind:rules="teamRules"
                                    required
                                >
                                </v-text-field>
                                <v-text-field name="location" label="Location" v-model="location">
                                </v-text-field>
                                <v-text-field name="manager_name" label="Manager" v-model="manager">
                                </v-text-field>
                                <v-text-field name="manager_email" label="Email" v-model="email">
                                </v-text-field>
                                <v-text-field name="manager_phone" label="Phone" v-model="phone">
                                </v-text-field>
                                <v-layout row wrap mb-4>
                                    <v-flex xs6>
                                        <v-text-field
                                            name="colour"
                                            label="Colour"
                                            v-model="colour"
                                            v-bind:readonly="readonly"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-flex offset-xs1 xs5>
                                        <v-btn
                                            v-bind:style="
                                                'text-transform: none; text-align: center; width: 100%;' +
                                                    setBackgroundColour()
                                            "
                                            font-weight-bold
                                            depressed
                                            >{{ team }}</v-btn
                                        >
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm3>
                                        <v-slider
                                            v-model="red"
                                            thumb-label="always"
                                            thumb-color="red"
                                            color="red"
                                            min="0"
                                            max="255"
                                        ></v-slider>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-flex xs12 sm3>
                                        <v-slider
                                            v-model="green"
                                            thumb-label="always"
                                            thumb-color="green"
                                            color="green"
                                            min="0"
                                            max="255"
                                        ></v-slider>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-flex xs12 sm3>
                                        <v-slider
                                            v-model="blue"
                                            thumb-label="always"
                                            thumb-color="blue"
                                            color="blue"
                                            min="0"
                                            max="255"
                                        ></v-slider>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                                >Create Team</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { useWhiteTextHex } from '../utils/colour-utils'

export default {
    name: 'AdminTeamsNew',
    data() {
        return {
            exact: true,
            valid: false,
            team: '',
            teamRules: [
                (v) => !!v || 'Team name is required',
                (v) => v.length >= 2 || 'Team must be greater than 2 characters',
                (v) => {
                    let teams = this.$store.state.teams
                    let unique = true

                    teams.forEach((team) => {
                        if (team.team === v) {
                            unique = false
                        }
                    })

                    return unique || 'Team name already exists.'
                }
            ],
            location: '',
            manager: '',
            email: '',
            phone: '',
            red: 1,
            green: 1,
            blue: 1,
            readonly: true
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('createTeam', {
                    team: this.team,
                    location: this.location,
                    manager_name: this.manager,
                    manager_email: this.email,
                    manager_phone: this.phone,
                    colour: this.colour
                })
            }
        },
        setBackgroundColour() {
            if (useWhiteTextHex(this.colour)) {
                return `background-color: ${this.colour}; color: #ffffff;`
            } else {
                return `background-color: ${this.colour}; color: #000000;`
            }
        }
    },
    computed: {
        colour() {
            let redHex = this.red.toString(16).toUpperCase()
            let greenHex = this.green.toString(16).toUpperCase()
            let blueHex = this.blue.toString(16).toUpperCase()

            redHex.length === 1 ? (redHex = '0' + redHex) : redHex
            greenHex.length === 1 ? (greenHex = '0' + greenHex) : greenHex
            blueHex.length === 1 ? (blueHex = '0' + blueHex) : blueHex

            return `#${redHex.toString(16)}${greenHex.toString(16)}${blueHex.toString(16)}`
        }
    }
}
</script>

<style scoped></style>
